import type { Avfall, AvfallType } from '../../services/rtkApi';

/**
 * Determine if avfall type is sorted based on ID
 * Unsorted avfall types start with '9'
 */
export const isSortedType = (
    avfalltype: AvfallType | undefined,
): boolean | null => {
    if (avfalltype === undefined) return null;
    return !avfalltype.avfallTypeId.toString().startsWith('9');
};

/**
 * Calculate total mengde from avfall array
 */
export const calculateMengde = (
    avfall: Array<Avfall>,
    sorted: boolean | undefined,
): number => {
    if (sorted !== undefined) {
        avfall = avfall.filter((a) => a.sortert === sorted);
    }

    return avfall.reduce((sum, a) => sum + a.mengde, 0) || 0;
};

/**
 * Create a new empty Avfall row
 */
export const createEmptyAvfall = (): Avfall => ({
    id: 0,
    sortert: null,
    avfallType: '',
    avfallTypeId: null,
    antallTransporter: 0,
    beskrivelse: '',
    mengde: 0,
});
